export default "__VITE_PUBLIC_ASSET__2285364b__"